import React, { useState } from 'react';
import styled from '@emotion/styled';
import CustomerForm from './CustomerForm';
import SuccessAnimation from './SuccessAnimation';

const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: var(--al-bg);
  padding: 30px;
  border-radius: 4px;
  width: 500px;
  max-width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  h2 {
    color: white;
    font-family: 'Montserrat', sans-serif;
    font-size: 24px;
    margin-bottom: 20px;
    font-weight: 600;
    text-transform: uppercase;
  }
`;

const AddCustomer = ({ isOpen, onClose, onAdd, initialData = {} }) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [formData, setFormData] = useState({
    client: initialData?.client || '',
    contact: initialData?.contact || '',
    email: initialData?.email || '',
    billingEmail: initialData?.billingEmail || '',
    phone: initialData?.phone || ''
  });

  if (!isOpen) return null;

  const handleSubmit = async (customerData) => {
    await onAdd(customerData);
    setShowSuccess(true);
    // Close modal after success animation completes
    setTimeout(onClose, 2500);
  };

  return (
    <Modal onClick={onClose}>
      <ModalContent onClick={e => e.stopPropagation()}>
        <h2>Add New Customer</h2>
        <CustomerForm 
          onSubmit={handleSubmit}
          onCancel={onClose}
          initialData={initialData}
        />
        {showSuccess && (
          <SuccessAnimation 
            onComplete={() => setShowSuccess(false)}
          />
        )}
      </ModalContent>
    </Modal>
  );
};

export default AddCustomer; 